import "./App.css";
import { Route, Routes, useNavigate } from "react-router-dom";
import React from "react";
import { routes } from "utils/routes/routes";
import { useSelector } from "react-redux";
import { IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "utils/NavigationClient";

type AppProps = {
  pca: IPublicClientApplication;
};

export default function App({ pca }: AppProps) {
  const auth = useSelector((state: any) => state.auth);
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);
  return (
    <>
      {auth.auth.msUsername && (
        <>
          <Routes>
            {routes.map((route) => (
              <Route key={route.id} path={route.path} element={route.element} />
            ))}
          </Routes>
        </>
      )}
    </>
  );
}
